import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ISite } from "../../types/siteType";

export interface InitialState {
  openAddStudyModal: any;
  openAddSiteModal: any;
  isEditSite: any;
  openDeleteSite: any;
  studyDetails: any;
  siteDetails: ISite;
  selectedStudy: string;
  armsError: boolean;
  openAddCentralLabModal: boolean;
  openDeleteStudyDialog: boolean;
  isEditStudy: boolean;
}

const initialState: InitialState = {
  openAddStudyModal: false,
  openAddSiteModal: false,
  isEditSite: false,
  openDeleteSite: false,
  siteDetails: {
    id: "",
    study_id: "",
    site_id: "",
    name: "",
    street_address: "",
    unit_number: "",
    city: "",
    state: "",
    country: "",
    postal_code: "",
    contact_name: "",
    contact_email: "",
    contact_phone_number: "",
    principal_investigator: "",
    site_status: "",
    country_code: "",
    country_value_code: "",
    site_status_code: "",
    site_status_value_code: "",
  },
  selectedStudy: "",
  studyDetails: {},
  armsError: false,
  openAddCentralLabModal: false,
  openDeleteStudyDialog: false,
  isEditStudy: false,
};

export const studiesSlice = createSlice({
  name: "studies",
  initialState,
  reducers: {
    setOpenAddStudyModal: (state: any, action: PayloadAction<any>) => {
      state.openAddStudyModal = action.payload;
    },
    setOpenAddSiteModal: (state: any, action: PayloadAction<any>) => {
      state.openAddSiteModal = action.payload;
    },
    setSiteDetails: (state: any, action: PayloadAction<ISite>) => {
      state.siteDetails = action.payload;
    },
    setSelectedStudy: (state: any, action: PayloadAction<string>) => {
      state.selectedStudy = action.payload;
    },
    setStudyData: (state: any, action: PayloadAction<any>) => {
      state.studyDetails = action.payload;
    },
    setIsEditSite: (state: any, action: PayloadAction<any>) => {
      state.isEditSite = action.payload;
    },
    setOpenDeleteSite: (state: any, action: PayloadAction<any>) => {
      state.openDeleteSite = action.payload;
    },
    setArmsError: (state: any, action: PayloadAction<any>) => {
      state.armsError = action.payload;
    },
    setOpenAddCentralLabModal: (state: any, action: PayloadAction<any>) => {
      state.openAddCentralLabModal = action.payload;
    },
    setOpenDeleteStudyDialog: (state: any, action: PayloadAction<any>) => {
      state.openDeleteStudyDialog = action.payload;
    },
    setIsEditStudy: (state: any, action: PayloadAction<any>) => {
      state.isEditStudy = action.payload;
    },
  },
});

export const {
  setOpenAddStudyModal,
  setOpenAddSiteModal,
  setSiteDetails,
  setIsEditSite,
  setStudyData,
  setOpenDeleteSite,
  setSelectedStudy,
  setArmsError,
  setOpenAddCentralLabModal,
  setOpenDeleteStudyDialog,
  setIsEditStudy,
} = studiesSlice.actions;
